import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
// import Icon from "../atoms/Icon/Icon";
import React, { useEffect, useState } from "react";
import { Icon } from "../atoms";

const WrapperDiv = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 50px;
  height: 50px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  background: ${(theme: any) => theme.theme.bgColor3};
  a {
    display: inline-block;
    height: 24px;
    width: 24px;
  }
`;

const FontIcon = styled.span`
  font-size: 24px;
  color: ${(theme: any) => theme.theme.Light3};
  &.active {
    color: ${(theme: any) => theme.theme.white};
  }
`;

const MobileDashboardFooter: React.FC = () => {
  const location = useLocation();
  const [path, setPath] = useState("/");

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setPath("/");
        break;
      case "/crypto/trade/easy":
        setPath("easy");
        break;
      case "/markets":
        setPath("market");
        break;
      case "/user/portfolio":
        setPath("portfolio");
        break;
      case "/collateral":
        setPath("collateral");
        break;
    }
  }, [location.pathname]);

  return (
    <WrapperDiv>
      <Link to="/">
        {path === "/" ? (
          <FontIcon className="icon-Dashboard-on active">
            <span className="path1"></span>
            <span className="path2"></span>
          </FontIcon>
        ) : (
          <FontIcon className="icon-Dashboard-off"></FontIcon>
        )}
      </Link>
      <Link to="/markets">
        {path === "market" ? (
          <FontIcon className="icon-Markets-on active">
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
            <span className="path4"></span>
          </FontIcon>
        ) : (
          <FontIcon className="icon-Markets-off"></FontIcon>
        )}
      </Link>
      <Link to="/crypto/trade/easy">
        {path === "easy" ? (
          <FontIcon className="icon-easyTrade-on active">
            <span className="path1"></span>
            <span className="path2"></span>
          </FontIcon>
        ) : (
          <FontIcon className="icon-easyTrade-off"></FontIcon>
        )}
      </Link>
      <Link to="/collateral">
        {path === "collateral" ? (
          <Icon name={"shieldDoneFilled"} width={24} height={24} />
        ) : (
          <Icon name={"shieldDone"} width={24} height={24} />
        )}
      </Link>
      <Link to="/user/portfolio">
        {path === "portfolio" ? (
          <FontIcon className="icon-Wallet-on active">
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
          </FontIcon>
        ) : (
          <FontIcon className="icon-Wallet-off"></FontIcon>
        )}
      </Link>
    </WrapperDiv>
  );
};

export default MobileDashboardFooter;
